import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/blocks/PageHero';
import { MediaCard } from '../components/blocks/MediaCard';
import { QuoteBlock } from '../components/QuoteBlock';
import { SectionDivider, SURFACE } from '../components/blocks/SectionDivider';
import { useSeo } from '../lib/useSeo';
import { audioVideoSchema } from '../lib/schema';

/**
 * PAGE: /creative-corner
 * WORDPRESS: page template `page-creative-corner.php`
 *
 * Blocks: hero → media_card → prose → quote
 */

const HERO_IMAGE = 'https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?auto=format&fit=crop&q=80&w=2000';

/** ACF: repeater `creative_corner_videos` */
const videos = [{
  id: 'QEB_XDkymGc',
  title: 'How to prepare a Christmas cake? — Milangela',
  description: 'A warm, unhurried culinary session from the Creative Corner.',
  url: 'https://www.youtube.com/watch?v=QEB_XDkymGc',
  thumbnail: 'https://img.youtube.com/vi/QEB_XDkymGc/sddefault.jpg'
}];
export function CreativeCorner() {
  useSeo({
    title: 'Creative Corner',
    description: 'Unveil your hidden gifts and indulge in art and craft — painting, drawing, writing, floral arrangements, sewing, knitting and culinary journeys.',
    path: '/creative-corner',
    image: HERO_IMAGE,
    breadcrumbs: [{
      name: 'Creative Corner',
      path: '/creative-corner'
    }],
    schema: videos.map(video => audioVideoSchema({
      type: 'VideoObject',
      name: video.title,
      description: video.description,
      path: '/creative-corner',
      image: video.thumbnail,
      externalUrl: video.url
    }))
  });
  return <div className="flex min-h-screen flex-col bg-cream" data-id="element-512" data-mp="9ulmwsn2h4hw">
      <Header data-id="element-513" data-mp="26nwxu1q2lsnp" />

      <main data-id="element-514" data-mp="26ogd1aoc62y1">
        <PageHero heading="Creative corner" subheading="made by Milangela's Soul Garden" image={HERO_IMAGE} imageAlt="Zen garden sand raked around smooth stones" align="center" overlay="light" size="compact" dividerFill={SURFACE.cream} data-id="element-515" data-mp="26oyjf04ppxjo" />

        <section className="bg-cream px-6 py-20 md:py-28" data-id="element-516" data-mp="1yosajofjgvsu">
          <div className="mx-auto mb-14 max-w-4xl space-y-8" data-id="element-517" data-mp="2dl172i81ov1k">
            {videos.map(video => <MediaCard key={video.id} title={video.title} thumbnail={video.thumbnail} thumbnailAlt={video.title} url={video.url} linkLabel="Watch on YouTube" data-id="element-518" data-mp="28l5b969i49x3" />)}
          </div>

          <div className="mx-auto max-w-2xl space-y-6 text-center font-light leading-relaxed text-charcoal-50" data-id="element-519" data-mp="2wb94qksz6tad">
            <p data-id="element-520" data-mp="2rcxwgeibwqu9">
              How to unveil the hidden gifts, fulfill wishes to indulge in art
              and craft that have been accused to be of no value and “shamed out
              of us”. Brené Brown argues that{' '}
              <em className="font-serif text-charcoal" data-id="element-521" data-mp="31bx17lzz42bz">
                “Unused creativity is not benign. It turns into grief, sorrow,
                rage, judgment, shame…”
              </em>
            </p>
            <p data-id="element-522" data-mp="3ovd3ej3a8slx">
              Be prepared for painting, drawing, writing, making floral
              arrangements, sewing, knitting, culinary journeys, and more.
            </p>
            <p className="pt-4 font-serif text-xl italic text-charcoal md:text-2xl" data-id="element-523" data-mp="3fv81goguymf5">
              Join me and be amazed at what happens…
            </p>
          </div>
        </section>

        <SectionDivider from={SURFACE.cream} to={SURFACE.sage} data-id="element-524" data-mp="35zdan62hdl1a" />

        <QuoteBlock quote="One day or day one?" author="— You decide" bgClass="bg-sage-50" accentClass="text-sage-600" data-id="element-525" data-mp="2s7qdz54mmahz" />

        <SectionDivider from={SURFACE.sage} to={SURFACE.charcoal} data-id="element-526" data-mp="2w6fmokepz3va" />
      </main>

      <Footer data-id="element-527" data-mp="2i9soyfey09ob" />
    </div>;
}